import { render, staticRenderFns } from "./teaTalk.vue?vue&type=template&id=031bbb13&scoped=true&"
import script from "./teaTalk.vue?vue&type=script&lang=js&"
export * from "./teaTalk.vue?vue&type=script&lang=js&"
import style0 from "./teaTalk.vue?vue&type=style&index=0&id=031bbb13&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031bbb13",
  null
  
)

export default component.exports